import styled from '@emotion/styled';

export const RankingStrategyContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;
